<template>
    <q-list bordered>
        <q-item-label header class="row justify-between bg-grey-4">
            <div class="text-black text-h6">{{$t('transfers.send_money_steps.transfer_time')}}</div>
        </q-item-label>

        <q-item class="q-pt-md text-grey-10">
            <div><q-icon name="fas fa-stopwatch" color="primary" size="xs"/>&nbsp;<span dir="ltr">{{transferTime}}</span></div>
        </q-item>
        <q-item class="q-py-xs text-grey-10">
            <div>
                <q-icon name="fa fa-circle-info" color="input-color" size="xs"/>&nbsp;
                {{$t('transfers.send_money_steps.the_transfer_time_window_is_target_only_and_it_s_subject_to_the_availability_of_the_bank_networks_and_local_operators')}}
            </div>
        </q-item>
    </q-list>
</template>
<script>
export default {
    name: "TransferTime",
    model: {
        prop: 'transfer',
        event: 'change'
    },
    props: {
        transfer: {
            type:Object,
            required: true
        },
        transferTime: {
            type: String,
            required: true
        }
    },
    computed: {
        total_amount() {
            return parseFloat(this.transfer.origin_amount + this.transfer.service_fee - this.transfer.referral_earnings)
        }
    },
    data() {
        return {

        }
    },
    methods: {},
    mounted() {
        this.transfer.type = 'asap'
    },
    components: {},
}
</script>
<style>

</style>
